var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:['shadowed-image' ,'position-'+_vm.position]},[(_vm.type=='img')?_c('img',{staticClass:"image",attrs:{"src":_vm.src}}):_vm._e(),_vm._v(" "),(_vm.type=='video')?_c('BackgroundVideo',{staticClass:"image",attrs:{"src":_vm.src}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.shadow}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8570b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShadowedImage.vue
// module id = null
// module chunks = 